import React ,{ useState, useEffect } from "react";
import "../Style/about.css";
import NavsList from "./NavsList";
import FullVideo from "./FullVideo";
import { MyComponent, scrollToTop } from "./Methods";
export default function About(){
    const [isLoading,setIsLoading] = useState(true);
    const [data,setData] = useState({});
    const [showFullVideo ,setShowFullVideo] = useState(false);

    useEffect(() => {
        document.title = "درباره ما";
        setTimeout(() => {
            scrollToTop();
            setIsLoading(false);
            setData({
                shortDesc : "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با ",
                videoLink :"/video/horizontalVideo.mp4",
                videoCover: "/image/courseImg.webp",
                description : "<p>حسرت، یکی از سنگین‌ترین حس‌هایی که میشه باهاش روبه‌رو شد. این حس مثل یه سایه‌ست که همیشه پشت سرمون میاد، هر جا می‌ریم و هر تصمیمی که می‌گیریم، خودش رو بهمون یادآوری می‌کنه.</p><p>از همه بدتر اینکه درد حسرت تا سال‌ها با ما همراه می‌مونه. </p><a>مشاهده توضیحات</a><p>خلاصه کتاب حسرت و فرصت اثر دن سالیوان و بنجامین هاردی راهی برای بیشتر بهره‌بردن از زندگیه؛ اونم بدون اینکه اسیر حسرت‌هایی بشیم که شاید همین الان توی ذهنمون جا خوش کرده باشن.</p><p>این کتاب می‌خواد بهمون یاد بده که چطور می‌تونیم با تغییر ذهنیتمون، دیدگاه‌مون نسبت به موقعیت‌های مختلف زندگی رو تغییر بدیم. وقتی به جایی می‌رسیم که دو تا انتخاب داریم – یکی که راحت و بی‌خطره، و یکی دیگه که شاید ریسکی باشه ولی پتانسیل بزرگی برای موفقیت داره – سالیوان می‌گه باید به دومی فکر کنیم. چون هر چی بیشتر به سمت فرصت‌ها بریم، کمتر اسیر حسرت می‌شیم.</p><p>یه نکته جالب دیگه که سالیوان توی کتابش مطرح می‌کنه، اینه که حسرت‌ها همیشه از کارهایی که انجام ندادیم، شکل می‌گیرن. اون لحظه‌هایی که به جای اینکه دست به عمل بزنیم، نشستیم و تماشا کردیم؛ بنابراین اگه آدم عملگرایی نیستی اما توی سرت پر از ایده‌ها و فکره، حتما این کتاب می‌تونه خیلی کمکت کنه.</p><p>«حسرت و فرصت» کتابیه که بهمون کمک می‌کنه بفهمیم کجاها تو زندگی داریم از روی ترس عقب‌نشینی می‌کنیم و چطور می‌تونیم این عادت رو ترک کنیم. به قول سالیوان، زندگی پر از فرصت‌هاییه که فقط منتظرمون هستن، ولی باید جراتش رو داشته باشیم که بهشون نزدیک بشیم و ازشون استفاده کنیم. چون در نهایت، کسی که فرصت‌ها رو می‌قاپه، همونیه که کمتر اسیر حسرت‌ها میشه.</p>",
            });
        }, 2000);
    }, []);
    return <>
    {
        isLoading ? <section className="flex flexCol loadingAboutSection container">
            <div className="flex flexCol navLoading rel">
                <div className="loaderItem"></div>
            </div>
            <div className="aboutIntroDiv grid">
                <div className="flex flexCol aboutIntroLeftDiv rel">
                    <div className="loaderItem"></div>
                </div>
                <div className="flex flexCol aboutIntroRightDiv rel">
                    <div className="loaderItem"></div>
                </div>
            </div>
            <div className="flex flexCol videoLoadingDiv rel">
                <div className="loaderItem"></div>
            </div>
        </section> : <>
            <NavsList data={[{name:"درباره ما",link:""}]} />
            <section className="aboutIntroSection grid container">
                <button className="flex flexCol courseFirstLeftDiv rel" onClick={()=>setShowFullVideo(true)}>
                    <img src={data.videoCover} alt="درباره ما" className="courseLeftDivImg" width={"100%"} draggable="false" />
                    <svg className="coursePlayIcon" stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M133 440a35.37 35.37 0 0 1-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0 1 35.77.45l247.85 148.36a36 36 0 0 1 0 61l-247.89 148.4A35.5 35.5 0 0 1 133 440z"></path></svg>
                </button>
                <div className="flex flexCol introShortDesc gap5">
                    <h1 className="faFont textSize16 textClr3 aboutIntroTitle">
                        سایت آموزشی با‌ما‌می‌رسی
                    </h1>
                    <p className="faFont textSize11 textClr5 justifyText">
                        {
                            data.shortDesc
                        }
                    </p>
                </div>
            </section>
            <section className="aboutDescription grid container">
                <div className="flex flexCol aboutRightDiv">
                    <h3 className="faFont textSize14 textClr3">
                        درباره ما بیشتر بدانید
                    </h3>
                    <div className="flex flexCol blogsContent">
                        <div className="flex flexCol blogContentList faFont content rel">
                            {
                                MyComponent({htmlContent:data.description})
                            }
                        </div>
                    </div>
                </div>
                <div className="flex flexCol aboutLeftDiv">
                    <img src="/image/about.webp" alt="about bamamiresi" className="aboutLeftDivImg" draggable="false" width={450}/>
                </div>
            </section>
            <FullVideo data={{videoLink : data.videoLink}} showFullVideo={showFullVideo} setShowFullVideo={setShowFullVideo} />
        </>
    }
    </>
    
}